import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import AllDetailRequest from "../../components/AllDetailRequest";
import ERModal from "../../components/ERModal";
import { getLeaveDetail } from "../../core/actions/leaveDetailAction";
import { deleteError, updateRequest } from "../../core/actions/updateRequestAction";
import functionCommon from "../../core/common/function";
import { commonConstants } from "../../core/constant/common.constants";
const initParam = {
    paramLeaveDetail: {
        leaveRequestId: "",
        hasPermission: "",
    },
    updateRequestParam: {
        requestId: "",
        action: "",
    },
};

const AllDetailRequestPage = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const leaveDetail = useSelector((state) => state.leaveDetailReducer.leaveDetail);
    const updateRequestStore = useSelector((state) => state.updateRequestReducer);
    const isLoadingDetail = useSelector((state) => state.leaveDetailReducer.isloading);
    const [message, setMessage] = useState(null);
    const [modalStyle, setModalStyle] = useState(null);
    const [textContent, setTextContent] = useState(null);
    const [checkError, setCheckError] = useState(true);
    const [flagCancel, setFlagCancel] = useState(false);
    const [open, setOpen] = useState(false);
    const { errorCode, isLoading, isError } = updateRequestStore;
    const dispatch = useDispatch();
    initParam.paramLeaveDetail = {
        leaveRequestId: params.get("leaveRequestId"),
        hasPermission: params.get("hasPermission"),
    };

    const triggerMessage = () => {
        setTimeout(() => {
            setMessage(null);
            dispatch(deleteError());
        }, 2000);
    };

    const triggerReload = () => {
        setTimeout(() => {
            history.push("/all-leave-request");
        }, 2500);
    };

    const handelClose = () => {
        setOpen(false);
        dispatch(deleteError());
        setCheckError(!checkError);
        setFlagCancel(false);
    };

    useEffect(() => {
        dispatch(getLeaveDetail(initParam.paramLeaveDetail));
    }, []);

    useEffect(() => {
        if (errorCode === commonConstants.ERROR_CODE_FOR_YEAR) {
            setTextContent(t("labels.approveLeaveError"));
            setModalStyle("errorModal");
            setOpen(true);
        } else if (errorCode) {
            setMessage(t(`message.${errorCode}`));
            triggerMessage();
            triggerReload();
        } else {
            setMessage(null);
            setTextContent(null);
        }
    }, [errorCode]);

    const handleApprove = () => {
        setFlagCancel(true);
        initParam.updateRequestParam = {
            action: 0,
            requestId: Number(params.get("leaveRequestId")),
        };
        dispatch(updateRequest(initParam.updateRequestParam));
    };

    const handleReject = () => {
        setFlagCancel(true);
        initParam.updateRequestParam = {
            action: 1,
            requestId: Number(params.get("leaveRequestId")),
        };
        dispatch(updateRequest(initParam.updateRequestParam));
    };

    return (
        <div className="managementpage-wrap">
            <h2 className="page-heading">
                <span onClick={functionCommon.goToPage("/my-leave-request")}>{t("labels.leaveManagemnet")}</span>
                <span onClick={functionCommon.goToPage("/all-leave-request")}>/ {t("labels.allLeaveRequest")}</span>
                <span onClick={functionCommon.goToPage("/all-leave-request/leave-history/detail" + search)}>
                    / {t("labels.detail")}
                </span>
            </h2>
            {message && (
                <div className={`${isError ? "error-message" : "success-message"}`}>{message}</div>
            )}
            <AllDetailRequest
                isLoading={isLoading}
                handleApprove={handleApprove}
                handleReject={handleReject}
                leaveDetail={leaveDetail}
                checkError={checkError}
                flagCancel={flagCancel}
                isLoadingDetail={isLoadingDetail}
            />
            <ERModal
                size={"mini"}
                open={open}
                title={t("labels.error")}
                handleClose={handelClose}
                modalStyle={modalStyle}
                textContent={textContent}
            />
        </div>
    );
};

export default AllDetailRequestPage;
